import { TimelineMax } from 'gsap';
import { random } from 'lodash';

const FilmGlitch = (element) => {
  const tl = new TimelineMax({
    paused: true,
    repeat: -1,
  });
  tl.addLabel('start')
    .addLabel('delay', 'start+=1.3')
    .to(element, 0, {
      x: random(-10, 10),
      y: random(-10, 10),
    }, 'delay')
    .to(element, 0, {
      x: random(-10, 10),
      y: random(-10, 10),
    }, 'delay+=0.1')
    .to(element, 0, {
      x: random(-10, 10),
      y: random(-10, 10),
    }, 'dealy+=0.2')
    .to(element, 0, {
      x: 0,
      y: 0,
    }, 'delay+=0.3');
  return tl;
};

export default FilmGlitch;
